import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-hour-picker-input',
  templateUrl: './hour-picker-input.component.html',
  styleUrls: ['./hour-picker-input.component.scss'],
})
export class HourPickerInputComponent {
  @ViewChild('detailsGroup') detailsGroup!: ElementRef<HTMLDetailsElement>;

  @Input() label: string = 'Faixa horária';

  @Input() start: string = '';
  @Input() end: string = '';

  @Input() startLabel: string = 'Início';
  @Input() endLabel: string = 'Fim';

  @Output() startChange = new EventEmitter<string>();
  @Output() endChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) {}

  get displayValue(): string {
    if (this.start !== '' && this.end !== '') {
      return `${this.start} - ${this.end}`;
    }
    if (this.start !== '') {
      return `${this.start} -`;
    }
    if (this.end !== '') {
      return `- ${this.end}`;
    }
    return 'Selecione';
  }

  emitStartChange() {
    this.startChange.emit(this.start);
  }

  emitEndChange() {
    this.endChange.emit(this.end);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.detailsGroup && this.detailsGroup.nativeElement.open) {
        this.detailsGroup.nativeElement.open = false;
      }
    }
  }

  async openNativePicker(event: Event) {
    const ionInput = event.currentTarget as HTMLIonInputElement;

    const nativeInput = await ionInput.getInputElement();

    if (nativeInput && typeof nativeInput.showPicker === 'function') {
      try {
        nativeInput.showPicker();
      } catch (e) {
        console.warn('Browser prevented showing the picker');
      }
    }
  }
}
